import { AlertTriangle } from "lucide-react";

const points = [
  {
    head: "Availability is limited.",
    body: "High-profile assignments and standing details reduce open capacity quickly.",
  },
  {
    head: "Vulnerabilities compound.",
    body: "Every week without a strategy is another week of exposure for your people and brand.",
  },
  {
    head: "Readiness is rising.",
    body: "Organizations across the region are upgrading their security posture — quietly and decisively.",
  },
];

const go = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Fomo() {
  return (
    <section
      id="urgency"
      data-testid="fomo-section"
      className="relative py-24 sm:py-32 border-y border-white/5 bg-[#070707] bubaloo-grain"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
              <AlertTriangle
                size={16}
                className="text-[#1A5C40]"
                strokeWidth={1.5}
              />
              <span className="overline">A Note on Timing</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light leading-tight">
              The window for{" "}
              <span className="text-zinc-500">considered protection</span> is
              always before it is needed.
            </h2>
            <button
              onClick={() => go("inquiry")}
              data-testid="fomo-cta"
              className="btn-primary mt-10"
            >
              Secure Your Consultation
            </button>
          </div>

          <div className="lg:col-span-7 grid gap-5">
            {points.map((p, i) => (
              <div
                key={p.head}
                data-testid={`fomo-point-${i}`}
                className="reveal border border-white/8 bg-[#0c0c0c] p-7 hover:border-[#144A33] transition-colors"
              >
                <div className="flex items-start gap-6">
                  <span className="font-display text-zinc-700 text-3xl font-light w-10 shrink-0">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-display text-lg text-white font-medium">
                      {p.head}
                    </h3>
                    <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                      {p.body}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
